module.exports = __webpack_public_path__ + "img/choosing-m-shape.7bf1d6a9.png";